import React from "react";
import { graphql } from "gatsby";
import PropTypes from "prop-types";
import { Col, Container, Row } from "react-bootstrap";
import { Quote } from "react-bootstrap-icons";

import RichTextBlock from "./RichTextBlock";

import "../styles/components/Testimonials.scss";

const TestimonialCard = ({ copy }) => (
    <div className="testimonial-card p-4">
        <Quote className=" quotes mb-3" size={42} />
        <RichTextBlock content={copy} />
    </div>
);

TestimonialCard.propTypes = {
    copy: PropTypes.shape({
        raw: PropTypes.string.isRequired,
    }).isRequired,
};

const Testimonials = ({ title, testimonials }) => (
    <Container className="testimonials">
        <h2 className="text-center my-5 pt-4">{title}</h2>

        <Row className="justify-content-center">
            {testimonials.map(testimonial => (
                <Col key={testimonial.id} lg={4} className="my-3 my-lg-0">
                    <TestimonialCard {...testimonial} />
                </Col>
            ))}
        </Row>
    </Container>
);

export const query = graphql`
    fragment DynamicTestimonials on ContentfulTestimonialsSection {
        sys {
            contentType {
                sys {
                    id
                }
            }
        }
        title
        testimonials {
            id
            copy {
                raw
            }
        }
    }
`;

Testimonials.propTypes = {
    title: PropTypes.string.isRequired,
    testimonials: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            copy: PropTypes.shape({
                raw: PropTypes.string.isRequired,
            }).isRequired,
            image: PropTypes.shape({
                title: PropTypes.string,
                description: PropTypes.string,
                gatsbyImageData: PropTypes.object,
                file: PropTypes.shape({
                    contentType: PropTypes.string.isRequired,
                    url: PropTypes.string.isRequired,
                }),
            }),
        }).isRequired
    ).isRequired,
};

export default Testimonials;
